import { useMemo } from "react"

interface DashboardGridOverlayProps {
  cols: number
  rowHeight: number
  margin: [number, number]
  containerPadding: [number, number]
  canvasWidth: number
  canvasHeight: number
  visible: boolean
}

export default function DashboardGridOverlay({
  cols,
  rowHeight,
  margin,
  containerPadding,
  canvasWidth,
  canvasHeight,
  visible,
}: DashboardGridOverlayProps) {
  const verticalLines = useMemo(() => {
    const snapCols = [3, 4, 6]
    const usableWidth = canvasWidth - containerPadding[0] * 2
    const colWidth = (usableWidth - margin[0] * (cols - 1)) / cols

    const positions: number[] = []
    const seen = new Set<number>()

    for (const sc of snapCols) {
      const x = Math.round(containerPadding[0] + sc * (colWidth + margin[0]))
      if (!seen.has(x)) {
        seen.add(x)
        positions.push(x)
      }
    }

    return positions
  }, [cols, margin, containerPadding, canvasWidth])

  const horizontalLines = useMemo(() => {
    const positions: number[] = []
    const step = rowHeight + margin[1]
    for (let row = 1; ; row++) {
      const y = containerPadding[1] + row * step
      if (y >= canvasHeight - containerPadding[1]) {
        break
      }
      positions.push(Math.round(y))
    }

    return positions
  }, [rowHeight, margin, containerPadding, canvasHeight])

  if (!visible) {
    return null
  }

  return (
    <div className="DashboardGridOverlay">
      {verticalLines.map((x) => (
        <div
          key={`v-${x}`}
          className="DashboardGridOverlay__line DashboardGridOverlay__line--vertical"
          style={{ left: x }}
        />
      ))}
      {horizontalLines.map((y) => (
        <div
          key={`h-${y}`}
          className="DashboardGridOverlay__line DashboardGridOverlay__line--horizontal"
          style={{ top: y }}
        />
      ))}
    </div>
  )
}
